import Http from '@services/httpClient';
import Promise from 'bluebird';
import { saveAs } from 'file-saver';

const prefix = '/api/v1/documents';

export default {
  upload(body: object) {
    return new Promise((resolve, reject) => {
      Http.post({
        url: prefix,
        data: body,
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },

  downloadFile(arg: string) {
    return new Promise((resolve, reject) => {
      Http.download({
        url: `${prefix}/${arg}/download`,
      })
        .then((res) => {
          saveAs(res.data, arg);
          resolve();
        })
        .catch((e) => reject(e));
    });
  },
};
